export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" data-testid="logo-mark">
      <rect width="64" height="64" rx="14" fill="#0A2A1A" />
      <path
        d="M32 10c-10 0-16 7.6-16 17v27h32V27c0-9.4-6-17-16-17zm0 8.4c5 0 7.6 3.8 7.6 8.6V46H24.4V27c0-4.8 2.6-8.6 7.6-8.6z"
        fill="#C5A869"
      />
    </svg>
  );
}

export default function Logo({ dark = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark />
      <div className="leading-tight">
        <p className={`font-heading font-bold text-lg ${dark ? "text-ivory" : "text-forest"}`}>نموذج عقاري</p>
        <p className={`text-[10px] tracking-[0.25em] font-heading ${dark ? "text-gold" : "text-gold-dark"}`}>
          REAL ESTATE DEMO
        </p>
      </div>
    </div>
  );
}
